﻿import { Directive } from "@app/components/directive";
import * as angular from "angular";
import { Dirs } from "@app/helpers/dirs";
import { NgComponent } from "@app/di/decorators";
import { Token } from "@app/di/token";

@NgComponent({
    token: Token.KbSlide,
    dependencies: [
    ]
})
export class KbSlide extends Directive {
    constructor() {
        super();

        this.restrict = "EA";
        this.replace = true;
        this.scope = {
            open: "="
        };
        this.transclude = true;
        this.template = Dirs.component("kb-slide");

        this.link = (scope: any, element, atts: any) => {
            // put a class on the body element in the form of
            // <slideid>-visible so that other elements can react
            // to the slide being open
            if (atts.id) {
                let className = atts.id + "-open";
                scope.$watch("open", newValue => {
                    if (angular.isDefined(newValue)) {
                        $("body").toggleClass(className, newValue);
                    }
                });
            }
            scope.clicked = () => {
                scope.open = false;
            };
            scope.$watch("open", newValue => {
                if (!newValue) {
                    $(element).find(".kb-slide__nav").scrollTop(0);
                }
            });
        };

    }
}
